import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDellComponent } from './simple-icons-dell.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDellComponent ],
    exports:      [ SimpleIconsDellComponent ],
    bootstrap:    []
})
export class SimpleIconsDellModule {}
